<template>
  <CCol xl="6" class="mb-3" v-if="galleriesPricelist.length > 0 && hasPerm('gallery.price_list')">
    <div class="overview-widget overview-galleries">
      <div class="d-flex overview-galleries__cont">
        <div>
          <div class="overview-galleries__icon">
            <CIcon name="cipBuilding02" size="custom" :height="28"/>
            <div class="overview-galleries__sub-icon">
              <CIcon name="cipPencil" size="custom" :height="12"/>
            </div>
          </div>
        </div>

        <div class="w-100">
          <div class="overview-widget__head">
            <div class="d-flex align-items-center">
              <h5 class="m-0" v-translate>Set the price list</h5>
              <PTooltip class="ml-2" :content="tooltip.content()" :color="tooltip.color"
                        :placement="tooltip.placement"/>
            </div>
          </div>
          <div class="overview-widget__body">
            <div class="overview-galleries__text mb-4" v-translate translate-context="event_wizard.overview">
              Choose a gallery below and set a price list for your photos.
            </div>
            <label class="small" v-translate translate-context="event_wizard.overview">Choose a gallery</label>
            <GalleriesDropDown :galleries="galleriesPricelist"
                               showMissingPriceList
                               icon="cipArrowNarrowUpRight" @select="routeToGallery"/>

            <PAlert color="warning" icon="cipAlertTriangle">
              <template v-translate translate-context="event_wizard.overview">
                The price list for some galleries is not yet active, photos will not be delivered until it is set
              </template>
            </PAlert>
          </div>
        </div>
      </div>
    </div>
  </CCol>
</template>

<script>
import {mapGetters} from "vuex";
import PTooltip from "@/domain/core/components/PTooltip.vue";
import GalleriesDropDown from "@/domain/eventWizard/components/overview/GalleriesDropDown.vue";
import PAlert from "@/components/PAlert.vue";
import {tooltipEventWizard} from "@/domain/eventWizard/components/overview/tooltip";

export default {
  name: "GalleriesPricelist",
  components: {PAlert, GalleriesDropDown, PTooltip},
  computed: {
    ...mapGetters('event', [
      'picaServiceId',
    ]),
    ...mapGetters('eventGallery', [
      'galleries',
    ]),
    galleriesPricelist() {
      return this.galleries.filter(g => g.missing_price_list || g.sub.some(s => s.missing_price_list))
    },
    tab() {
      let route = this.$route.matched.find(m => m.props?.default?.tab)
      if (route) return route.props.default.tab
      return "price_list"
    },
    tooltip() {
      return tooltipEventWizard.galleryPricelist
    }
  },
  methods: {
    routeToGallery(gallery) {
      this.$router.push({
        name: `eventWizard.gallery.${this.tab}`,
        params: {picaServiceId: this.picaServiceId, galleryId: gallery.id}
      })
    }
  }
}
</script>


<style scoped>

</style>